"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleCollapsedNav = toggleCollapsedNav;
exports.onNavStyleChange = onNavStyleChange;
exports.onLocaleChange = onLocaleChange;
exports.onNavTypeChange = onNavTypeChange;
exports.onTopNavColorChange = onTopNavColorChange;
exports.onHeaderNavColorChange = onHeaderNavColorChange;
exports.onMobileNavToggle = onMobileNavToggle;
exports.onSwitchTheme = onSwitchTheme;

var _Theme = require("../constants/Theme");

function toggleCollapsedNav(navCollapsed) {
  return {
    type: _Theme.TOGGLE_COLLAPSED_NAV,
    navCollapsed: navCollapsed
  };
}

function onNavStyleChange(sideNavTheme) {
  return {
    type: _Theme.SIDE_NAV_STYLE_CHANGE,
    sideNavTheme: sideNavTheme
  };
}

function onLocaleChange(locale) {
  return {
    type: _Theme.CHANGE_LOCALE,
    locale: locale
  };
}

function onNavTypeChange(navType) {
  return {
    type: _Theme.NAV_TYPE_CHANGE,
    navType: navType
  };
}

function onTopNavColorChange(topNavColor) {
  return {
    type: _Theme.TOP_NAV_COLOR_CHANGE,
    topNavColor: topNavColor
  };
}

function onHeaderNavColorChange(headerNavColor) {
  return {
    type: _Theme.HEADER_NAV_COLOR_CHANGE,
    headerNavColor: headerNavColor
  };
}

function onMobileNavToggle(mobileNav) {
  return {
    type: _Theme.TOGGLE_MOBILE_NAV,
    mobileNav: mobileNav
  };
}

function onSwitchTheme(currentTheme) {
  return {
    type: _Theme.SWITCH_THEME,
    currentTheme: currentTheme
  };
}